
import React, { Component } from "react";
import {
    GetGHGEstimationUrl
} from "../../config";


class ActivityDataRemoval extends Component {
    constructor(props) {
        super(props);
        this.state = {
            jwtToken: "",
            organizationId: "",
        };
    }

    componentDidMount() { }

    render() {
        debugger
        const { classes } = this.props;
        const src = GetGHGEstimationUrl() + "admin/activity-data-removal/listing?accessToken=" + localStorage.opsToken;
        ///listing?accessToken=" + localStorage.opsToken;
        return (
            <iframe title="Activity Data Removal"
                id="Activity Data Removal"
                src={src}
                style={{ width: "100%", height: "100vh", border: "none" }}
            />
        )
    }
};

export default ActivityDataRemoval;
